import React, { useContext, useEffect } from 'react';
import ExpansionPanel from '../../reusable/ExpansionPanel/ExpansionPanel.js';
import AIAnalysisCard from './AIAnalysisCard.js';
import GeneralEmptyState from '../../reusable/EmptyState/GeneralEmptyState/GeneralEmptyState.js';
import { messageManager } from '../../System/messageManager/messageManager.js';
import { NO_DATA_FOUND } from '../../../static/constants.js';
import { CostBenchmarkContext } from '../../../contexts/costBenchmarkingContext.js';
import { getAIAnalysis } from '../../../services/programService.js';
import '../CostBenchmark.scss';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';
import { LoaderContext } from '../../../contexts/loaderContext.js';
import DefaultBenchmarkEmptyState from './DefaultBenchmarkEmptyState.js';
import { buildFilters } from '../../CostBenchmark/costBenchmarkHelpers.js';

const KEYS = ['root_cause_analysis', 'efficiency_insights', 'best_practice_insights', 'strategic_recommendations', 'match_quality_assessment'];
const LABELS = ['Root Cause Analysis', 'Efficiency Insights', 'Best Practice Insights', 'Strategic Recommendations', 'Match Quality Assessment'];

const AIAnalysisTab = () => {
  const { loading, setLoading } = useContext(LoaderContext);
  const { currPage, matchSettings, defaultFilters, filteredData, AIAnalysisData, setAIAnalysisData, benchmarkData, refreshAIAnalysis, setRefreshAIAnalysis } = useContext(CostBenchmarkContext);
  const { nameConventions } = useNameConventions();

  const fetchAIAnalysis = async () => {
    try {
      setLoading(true);
      const filters = buildFilters({ filters: defaultFilters, matchSettings });
      const { data } = await getAIAnalysis(filters, filteredData);
      setAIAnalysisData(data);
    } catch {
      // error already handled in axios interceptor
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (refreshAIAnalysis) {
        await fetchAIAnalysis(filteredData);
        setRefreshAIAnalysis(false);
      }
    };
    fetchData();
  }, [benchmarkData, refreshAIAnalysis]);

  return (
    <div className="flexContainer withGap flexCenter marginTop scrollContainer">
      {!filteredData || !filteredData.length ? (
        loading ? <div /> : (
          <DefaultBenchmarkEmptyState />
        )
      ) : (
        LABELS.map((label, ind) => (
          <ExpansionPanel
            key={`${label}-${ind}`}
            title={LABELS[ind]}
            open={ind === 0 && currPage === 0}
          >
            <div className="flexContainer withGap">
              {loading ? <div /> : !AIAnalysisData || !AIAnalysisData[KEYS[ind]] ? (
                <GeneralEmptyState
                  title={messageManager(nameConventions).COST_BENCHMARK.EMPTY_STATE.NO_DATA_TO_DISPLAY}
                  src={NO_DATA_FOUND.source}
                  alt={NO_DATA_FOUND.alt}
                  showButton={false}
                />
              ) : (
                <AIAnalysisCard
                  key={label}
                  data={AIAnalysisData[KEYS[ind]]}
                  label={label}
                  className="ai-analysis-card"
                />

              )}
            </div>
          </ExpansionPanel>
        ))
      )}
    </div>
  );
};


export default AIAnalysisTab;
